import { useMemo } from "react";
import CustomerLayout from "./Layout";
import usePageMeta from "../../hooks/usePageMeta";
import useAuth from "../../hooks/useAuth";
import BackButton from "../../components/BackButton";
import PersonnelTempCalendar from "../../components/PersonnelTempCalendar";

const Availability = () => {
  usePageMeta("Availability");
  const auth = useAuth();

  const person = useMemo(() => {
    const id = Number(auth?.accountId || localStorage.getItem("accountId"));
    if (!Number.isFinite(id) || id <= 0) return null;
    const name = [auth?.firstName, auth?.lastName].filter(Boolean).join(" ").trim();
    return {
      id,
      name: name || auth?.name || "My Account",
    };
  }, [auth?.accountId, auth?.firstName, auth?.lastName, auth?.name]);

  return (
    <CustomerLayout active="availability">
      <div className="py-2 px-2 flex flex-col flex-1 min-h-0 overflow-hidden">
        <header className="flex-shrink-0 ml-3 mb-2">
          <div className="flex items-center gap-3">
            <BackButton />
            <h1 className="text-2xl font-semibold text-foreground">Availability</h1>
          </div>
        </header>

        <div className="h-[1px] bg-[#a15d33] mx-3 flex-shrink-0" />

        <div className="mt-4 mx-3 mb-4 flex-1 min-h-0 overflow-hidden flex flex-col border border-gray-200 rounded-xl bg-white">
          {person ? (
            <div className="flex-1 min-h-0 p-4 overflow-hidden">
              <PersonnelTempCalendar person={person} />
            </div>
          ) : (
            <div className="flex-1 flex items-center justify-center text-sm text-muted-foreground">
              Loading account…
            </div>
          )}
        </div>
      </div>
    </CustomerLayout>
  );
};

export default Availability;
